/* Uses the existing Eurus selector and its resolved-variant event. No cart API overrides. */
(() => {
  if (window.pbCroChoiceLoaded) return;
  window.pbCroChoiceLoaded = true;

  function mount(root) {
    if (root.pbCroMounted) return;
    root.pbCroMounted = true;
    const section = root.dataset.pbCroSection;
    const picker = () => root.querySelector('.variant-selects-main');
    function openPicker() {
      const el = picker();
      if (!el) return;
      el.scrollIntoView({ block: 'center', behavior: 'auto' });
      const shade = el.querySelector('[data-pb-cro-shade]') || el;
      const trigger = shade.querySelector('.pbx-trigger:not(.pbx-trigger--static), .pb-shade__trigger, [aria-haspopup]');
      if (trigger) trigger.click();
      else shade.querySelector('select, input[type="radio"]')?.focus();
    }
    root.addEventListener('click', (event) => {
      if (!event.target.closest('[data-pb-cro-choose]')) return;
      event.preventDefault();
      openPicker();
    });
    // A second selection must not submit the previous shade while Eurus fetches
    // the updated section (or if that request fails).
    root.addEventListener('change', (event) => {
      if (!picker()?.contains(event.target) || !event.target.matches('select, input[type="radio"]')) return;
      root.dataset.pbCroChoice = 'pending';
      root.dataset.pbCroFormVariant = '';
    }, true);
    // Guard Enter submission as well as pointer actions until the native response resolves.
    root.addEventListener('submit', (event) => {
      const formId = event.target.getAttribute('id');
      const mainForm = formId === `product-form-${section}` || formId === `product-form-sticky-${section}`;
      if (root.dataset.pbCroChoice !== 'pending' || !mainForm) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      openPicker();
    }, true);
    const onResolved = (event) => {
      if (!root.isConnected) {
        document.removeEventListener(event.type, onResolved);
        return;
      }
      const data = event.detail?.html?.querySelector('.variant-selects-main [data-selected-variant]');
      if (!data) return;
      let variant;
      try { variant = JSON.parse(data.textContent); } catch (_) { return; }
      // Eurus replaces buy-button markup after updating form inputs. Sync the
      // resolved ID to the final forms, including their serialized value.
      const formIds = [`product-form-${section}`, `product-form-installment-${section}`, `product-form-sticky-${section}`];
      root.querySelectorAll('form').forEach((form) => {
        if (!formIds.includes(form.getAttribute('id'))) return;
        const input = form.querySelector('input[name="id"]');
        if (!input) return;
        input.value = variant?.id ? String(variant.id) : '';
        input.setAttribute('value', input.value);
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
      const mainInput = root.querySelector(`form[id="product-form-${section}"] input[name="id"]`);
      // Non-sensitive diagnostic: confirm the public variant ID actually held by the form.
      root.dataset.pbCroFormVariant = mainInput?.value || '';
      for (const [key, value] of [['sku', variant?.sku], ['ean', variant?.barcode]]) {
        const wrap = root.querySelector(`[data-pb-${key}]`);
        const text = root.querySelector(`[data-pb-${key}-val]`);
        if (text) text.textContent = value || '';
        if (wrap) wrap.hidden = !value;
      }
      // A real but sold-out variant is a completed choice. Eurus keeps its ATC disabled.
      root.dataset.pbCroChoice = variant?.id && mainInput?.value === String(variant.id) ? 'ready' : 'pending';
    };
    document.addEventListener(`eurus:product-page-variant-select:updated:${section}`, onResolved);
  }
  function scan(scope) {
    if (scope.matches?.('[data-pb-cro-section]')) mount(scope);
    scope.querySelectorAll('[data-pb-cro-section]').forEach(mount);
  }
  function start() {
    scan(document);
    new MutationObserver((mutations) => {
      for (const mutation of mutations) for (const node of mutation.addedNodes) {
        if (node.nodeType === 1) scan(node);
      }
    }).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
